import { useEffect } from "react";
import { showErrorToast } from "../../../fnx/showError";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { rolPatchClearData, rolPostClearData, } from "../../../store/rol/actions";
export var useRolErrorHandling = function (_a) {
    var errorRolPost = _a.errorRolPost, errorRolPatch = _a.errorRolPatch, errorAssignPermissions = _a.errorAssignPermissions, setSeeToast = _a.setSeeToast;
    var dispatch = useDispatch();
    var t = useTranslation().t;
    useEffect(function () {
        if (errorRolPost) {
            showErrorToast(errorRolPost, setSeeToast, t);
            dispatch(rolPostClearData());
        }
    }, [errorRolPost]);
    useEffect(function () {
        if (errorRolPatch) {
            showErrorToast(errorRolPatch, setSeeToast, t);
            dispatch(rolPatchClearData());
        }
    }, [errorRolPatch]);
    useEffect(function () {
        if (errorAssignPermissions) {
            showErrorToast(errorAssignPermissions, setSeeToast, t);
            dispatch(rolPatchClearData());
        }
    }, [errorAssignPermissions]);
};
